export default {"src":"/_next/static/media/SETUP_GUIDE_ACTIVE.0df159ed.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};